module.exports = __webpack_public_path__ + "img/tool-539.dc69ab5.webp";